
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { PoolModel } from './Entities.GormCrm.Pool';
import { Model, ModelProperty } from 'models/Model';


export class PoolTeamModel extends Model<PoolTeamModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'poolTeam.property.id', isHidden: true },
		{ name: 'poolId', type: 'guid', languageString: 'poolTeam.property.poolId' },
		{ name: 'teamId', type: 'guid', languageString: 'poolTeam.property.teamId' },
		{ name: 'pool', type: 'PoolModel', languageString: 'poolTeam.property.pool', isHidden: true, isObject: true, new: () => { return new PoolModel }, properties: () => { return PoolModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public poolId?: string;
	public teamId?: string;
	public pool?: PoolModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.poolId = undefined;
		this.teamId = undefined;
		this.pool = undefined;
		
	}
	getProperties(){
		return PoolTeamModel.classProperties;
	}
}

